import * as React from 'react';

interface IAlertObj {
  [key: string]: {
    header: string;
    class: string;
  };
}

const alertObj: IAlertObj = {
  success: {
    header: 'Success!',
    class: '-success',
  },
  info: {
    header: 'Info!',
    class: '-info',
  },
  warning: {
    header: 'Warning!',
    class: '-warning',
  },
  danger: {
    header: 'Error!',
    class: '-danger',
  },
};


interface IAlert {
  type: string;
  text: string | JSX.Element[];
}

interface AlertStatusProps {
  alert: IAlert;
  close: () => void;
}

const Alert: React.SFC<AlertStatusProps> = (props) => {
  const { alert } = props;

  return (
    <div onClick={props.close} role="presentation" className={'alert alert' + alertObj[alert.type].class}>
      <strong>{alertObj[props.alert.type].header}</strong> {alert.text}
    </div>
  );
};


export default Alert;

